import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-hover-menu',
  imports: [MatMenuModule],
  templateUrl: './hover-menu.component.html',
  styleUrl: './hover-menu.component.scss'
})
export class HoverMenuComponent {
  timedOutCloser: ReturnType<typeof setTimeout> | undefined;

  mouseEnter(trigger: MatMenuTrigger) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
  }

  mouseLeave(trigger: MatMenuTrigger) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }
}
